<template>
    <div :class="['custom-card', 'cell', size, {disabled: disabled}]">
        <router-link :to="link">
            <div class="custom-card-image-container" v-if="hasImage">
                <slot name="image"></slot>
            </div>
            <div class="custom-card-text-container">
                <div class="flex-container align-justify align-middle" v-if="hasImage">
                    <p class="display-large color-black margin-0">{{ title }}</p>
                    <p class="display-xsmall color-battleship-gray margin-0"> {{ price }}</p>
                </div>
                <div class="align-middle" v-else>
                    <p class="display-large color-black">{{ title }}</p>
                    <p class="color-battleship-gray card-inner-description">
                        <slot name="description"></slot>
                    </p>
                    <p class="display-xsmall color-battleship-gray margin-0 text-right">{{ price }}</p>
                </div>
                <p v-if="description" class="display-small-tiny color-battleship-gray">{{ description }}</p>
            </div>
        </router-link>
    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator';

@Component
export default class Card extends Vue {
    @Prop(Boolean) readonly disabled!: boolean;
    @Prop(String) readonly title!: string;
    @Prop(String) readonly description!: string;
    @Prop(String) readonly price!: string;
    @Prop(Object) readonly link!: object;
    @Prop({type: String, default: 'large-4'}) readonly size!: string;

    get hasImage() {
        return this.$slots['image'];
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.custom-card {
    border-radius: $border-radius-card;
    box-shadow: 0 6px 18px 0 rgba(0, 0, 0, 0.06);
    background-color: var(--white);
    overflow: hidden; //to apply border radius on top too
    height: fit-content !important;
    transition: box-shadow ease 0.3s;

    &.disabled {
        opacity: 0.7;
        pointer-events: none;
    }

    &:hover {
        box-shadow: 0 6px 35px 0 rgba(0, 0, 0, 0.25);
    }

    .card-inner-description {
        padding: 10px 0;
    }

    .custom-card-image-container {
        background-color: var(--light-gray);
        height: 150px;

        img {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }


    .custom-card-text-container {
        padding: 20px;
        h5,p {
            margin-bottom: 0;
        }
    }
}
</style>

